<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SellProductFiltersComponent
                    ref="sell-product-search"
                    :showShops="true"
                    :enableFieldType="false"
                    :showSingleArticleFilter="false"
                    preselectFamily
                    @searchPressed="getProductsRating"
                    @changeFieldType="
                        (f) => {
                            fieldType = f;
                        }
                    "
                ></SellProductFiltersComponent>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <div v-if="!loading">
                    <v-data-table
                        dense
                        multi-sort
                        fixed-header
                        :search="search"
                        :item-class="rowColorClass"
                        :height="840"
                        :headers="headers"
                        :items="filteredData"
                        :options="{
                            sortBy: ['rating'],
                        }"
                        :items-per-page="100"
                        :footer-props="{
                            'items-per-page-options': [20, 50, 100, 200, -1],
                        }"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-text-field
                                    dense
                                    v-model="search"
                                    label="Cerca..."
                                    class="mx-2"
                                    style="max-width: 200px;"
                                >
                                </v-text-field>
                                <v-select
                                    dense
                                    v-model="ratingFilter"
                                    :items="ratingFilterOptions"
                                    label="Filtro Rating"
                                    class="mx-2"
                                    style="max-width: 150px;"
                                    @change="filterByRating"
                                >
                                </v-select>
                                <v-text-field
                                    dense
                                    v-model="rotazioneMin"
                                    label="Rotazione Min"
                                    type="number"
                                    step="0.01"
                                    class="mx-2"
                                    style="max-width: 120px;"
                                    @input="filterByRotazione"
                                >
                                </v-text-field>
                                <v-text-field
                                    dense
                                    v-model="rotazioneMax"
                                    label="Rotazione Max"
                                    type="number"
                                    step="0.01"
                                    class="mx-2"
                                    style="max-width: 120px;"
                                    @input="filterByRotazione"
                                >
                                </v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="success"
                                    small
                                    dark
                                    class="mb-2"
                                    @click="exportProductRating()"
                                >
                                    Esporta Rating
                                    <v-icon small> assessment </v-icon>
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.cod_articolo="{ item }">
                            <router-link
                                target="_blank"
                                :to="{
                                    name: 'product',
                                    query: {
                                        id: item.cod_articolo,
                                    },
                                }"
                            >
                                {{ item.cod_articolo }}
                            </router-link>
                        </template>
                        <template v-slot:item.prezzo_vendita="{ item }">
                            {{ item.prezzo_vendita | formatEuro }}
                        </template>
                        <template v-slot:item.prezzo_acquisto="{ item }">
                            {{ item.prezzo_acquisto | formatEuro }}
                        </template>
                        <template v-slot:item.prezzo_netto="{ item }">
                            {{ item.prezzo_netto | formatEuro }}
                        </template>
                        <template v-slot:item.prezzo_netto_tot="{ item }">
                            {{ item.prezzo_netto_tot | formatEuro }}
                        </template>
                        <template v-slot:item.rotazione="{ item }">
                            {{ item.rotazione | roundSecondDecimal }}
                        </template>
                        <template v-slot:item.saturazione="{ item }">
                            {{ item.saturazione | formatPercent }}
                        </template>
                        <template v-slot:item.margine_unitario="{ item }">
                            {{ item.margine_unitario | formatEuro }}
                        </template>
                        <template v-slot:item.margine_totale="{ item }">
                            {{ item.margine_totale | formatEuro }}
                        </template>
                        <template v-slot:item.vendite_totali="{ item }">
                            {{ item.vendite_totali | formatEuro }}
                        </template>
                        <template v-slot:item.spazio="{ item }">
                            {{ item.spazio | roundSecondDecimal }}
                        </template>
                        <template v-slot:item.euro_cm2="{ item }">
                            {{ item.euro_cm2 | formatEuro }}
                        </template>
                        <template v-slot:item.limit_vendita="{ item }">
                            {{ item.limit_vendita | formatEuro }}
                        </template>
                        <template v-slot:item.velocita="{ item }">
                            {{ item.velocita | roundSecondDecimal }}
                        </template>
                        <template v-slot:item.perla_nascosta="{ item }">
                            <div class="text-center">
                                <span
                                    v-if="item.perla_nascosta"
                                    style="color: green"
                                    >SI</span
                                ><span v-else style="color: red">NO</span>
                            </div>
                        </template>
                        <template v-slot:item.cumulata_margine="{ item }">
                            {{ item.cumulata_margine | formatPercent }}
                        </template>
                    </v-data-table>
                </div>
                <div v-else style="text-align: center">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss"></style>
<script>
import requests from "../../requests";
import ProductSellTable from "./ProductSellTable.vue";
import SellProductFiltersComponent from "../../components/SellProductFiltersComponent.vue";
import $ from "jquery";

const headers = [
    { text: "Codice Negozio", value: "cod_negozio", filterable: false },
    { text: "Codice Articolo", value: "cod_articolo" },

    { text: "Quantità", value: "qty_veduta", align: "end", filterable: false },
    {
        text: "Gicenza",
        value: "giacenza",
        align: "end",
        filterable: false,
    },
    {
        text: "Giacenza Media",
        value: "giacenza_media",
        align: "end",
        filterable: false,
    },
    {
        text: "Rotazione",
        value: "rotazione",
        align: "end",
        filterable: false,
    },

    { text: "Ultima Vendita", value: "data_ultima_vendita", filterable: false },
    { text: "Descrizione", value: "ar_descr", width: 250 },

    { text: "H(cm)", value: "altezza", align: "end" },
    { text: "W(cm)", value: "larghezza", align: "end" },
    { text: "P(cm)", value: "profondita", align: "end" },

    { text: "Codice Fornitore", value: "cod_fornitore" },
    {
        text: "Prezzo Vendita",
        value: "prezzo_vendita",
        align: "end",
        filterable: false,
    },
    {
        text: "Prezzo Acquisto",
        value: "prezzo_acquisto",
        align: "end",
        filterable: false,
    },
    {
        text: "Margine Netto",
        value: "prezzo_netto",
        align: "end",
        filterable: false,
    },
    {
        text: "Tot Ven prz acq.",
        value: "prezzo_netto_tot",
        align: "end",
        filterable: false,
    },

    { text: "Famiglia", value: "famiglia", width: 250 },
    { text: "Sottofamiglia", value: "sottofamiglia", width: 250 },

    {
        text: "Totale Acquisti",
        value: "totale_acquisti",
        align: "end",
        filterable: false,
    },
    {
        text: "Data Primo Acquisto",
        value: "data_primo_acquisto",
        filterable: false,
    },

    {
        text: "Saturazione",
        value: "saturazione",
        align: "end",
        filterable: false,
    },
    {
        text: "Margine Totale",
        value: "margine_totale",
        align: "end",
        filterable: false,
    },

    {
        text: "Ven. Tot. ls2",
        value: "vendite_totali",
        align: "end",
        filterable: false,
    },
    { text: "Spazio(cm²)", value: "spazio", align: "end", filterable: false },
    { text: "Fatturato/cm²", value: "euro_cm2", align: "end", filterable: false },
    {
        text: "Fatturato target EBITDA",
        value: "limit_vendita",
        align: "end",
        filterable: false,
    },
    {
        text: "Giorni Attivi",
        value: "giorni_attivi",
        align: "end",
        filterable: false,
    },
    {
        text: "Velocità(pz/gg)",
        value: "velocita",
        align: "end",
        filterable: false,
    },

    {
        text: "Perla Nascosta",
        value: "perla_nascosta",
        align: "center",
        filterable: false,
    },
    {
        text: "Cumulata Margine",
        value: "cumulata_margine",
        align: "end",
        filterable: false,
    },
    { text: "Pareto", value: "pareto", filterable: false, width: 125 },
    { text: "Rating", value: "rating", align: "center", filterable: false },
];

export default {
    name: "product-rating",
    components: { ProductSellTable, SellProductFiltersComponent },
    computed: {
        headers() {
            return headers;
        },
    },
    data: () => {
        return {
            loading: false,
            shops: [],
            data: [],
            order: {},
            search: "",
            fieldType: "prezzo",
            ratingFilter: "all",
            ratingFilterOptions: [
                { text: "Tutti", value: "all" },
                { text: "New", value: "New" },
                { text: "In osservazione", value: "In osservazione" },
                { text: "Rating", value: "rating" }
            ],
            rotazioneMin: "",
            rotazioneMax: "",
            filteredData: [],
        };
    },

    mounted() {
        console.log("Product Sell Mounted.");
        //let filters = this.$refs["sell-product-search"].getFilters();
        let filters = {};
        this.getProductsRating(filters);
    },

    methods: {
        getProductsRating(filters) {
            console.log(filters);
            this.loading = true;
            requests
                .getProductsRating(filters)
                .then((res) => {
                    this.data = res.data;
                    this.applyFilters();
                })
                .finally(() => {
                    this.loading = false;
                    //this.$refs["sell-product-search"].closeExpansionPanel();
                });
        },
        rowColorClass(row) {
            if (row.rating == "New") return "row-color-blue";
            if (row.rating == "In osservazione") return "row-color-pink";
            if (row.rating == "A") return "row-color-green";
            if (row.rating == "B") return "row-color-yellow";
            if (row.rating == "C") return "row-color-orange";
            if (row.rating == "D") return "row-color-red";
        },
        exportProductRating() {
            let filters = this.$refs["sell-product-search"].getFilters();
            // Add shop_id if not present (default to a shop ID)
            if (!filters.shop_id) {
                filters.shop_id = 7; // Default shop ID
            }
            window.open(
                "/api/products/rating/export?" + $.param(filters),
                "_blank"
            );
        },
        filterByRating() {
            this.applyFilters();
        },
        filterByRotazione() {
            this.applyFilters();
        },
        applyFilters() {
            let filtered = this.data;

            // Apply rating filter
            if (this.ratingFilter !== "all") {
                if (this.ratingFilter === "rating") {
                    // Show only products with A, B, C, D ratings (exclude New and In osservazione)
                    filtered = filtered.filter(item =>
                        ["A", "B", "C", "D"].includes(item.rating)
                    );
                } else {
                    filtered = filtered.filter(item => item.rating === this.ratingFilter);
                }
            }

            // Apply rotazione filter
            if (this.rotazioneMin !== "" && this.rotazioneMin !== null) {
                filtered = filtered.filter(item => {
                    if (!item.rotazione || item.rotazione === null || item.rotazione === undefined) {
                        return false; // Exclude items without rotazione data
                    }
                    return parseFloat(item.rotazione) >= parseFloat(this.rotazioneMin);
                });
            }

            if (this.rotazioneMax !== "" && this.rotazioneMax !== null) {
                filtered = filtered.filter(item => {
                    if (!item.rotazione || item.rotazione === null || item.rotazione === undefined) {
                        return false; // Exclude items without rotazione data
                    }
                    return parseFloat(item.rotazione) <= parseFloat(this.rotazioneMax);
                });
            }

            this.filteredData = filtered;
        }
    },

    filters: {
        roundSecondDecimal(value) {
            return Math.round(value * 100) / 100;
        },

        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
        formatPercent(value) {
            return value.toFixed(2) + "%";
        },
    },
};
</script>
<style lang="scss">
.row-color-blue {
    background-color: rgba($color: skyblue, $alpha: .50);
}
.row-color-pink {
    background-color: rgba($color: lightpink, $alpha: .50);
}
.row-color-green {
    background-color: lightgreen;
}
.row-color-yellow {
    background-color: rgba($color: yellow, $alpha: .50);
}
.row-color-orange {
    background-color: rgba($color: orange, $alpha: .50);
}
.row-color-red {
    background-color: rgba($color: red, $alpha: .50);
}
</style>
